import * as Yup from 'yup';

const regexWebsite =
  /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;

export const AddVenueSchema = Yup.object().shape({
  name: Yup.string().required('Name of venue is required'),
  business_address: Yup.string().required('Street Address is required'),
  zip: Yup.string()
    .required('ZIP code is required')
    .matches(/^\d{5}(-\d{4})?$/, 'Enter a valid ZIP code'),
  contact_name: Yup.string().required('Contact name is required'),
  contact_email: Yup.string().required('Contact email is required'),
  contact_phone_number: Yup.string().required('Contact phone number is required'),
  business_type: Yup.string().required('Business type is required'),
  business_number: Yup.string()
    .required('Business phone is required')
    .min(10, 'Business phone must contain 10 characters'),
  business_EIN: Yup.string().required('Business EIN is required'),
  description: Yup.string().required('Description is required'),
  fk_state: Yup.string().required('State is required'),
  fk_city: Yup.string().required('City is required'),
});
